// @flow
import { getThemeProp } from "./themeProps";

import type { ThemePropValue, UtilThemeProps } from "../types";

/**
 */
const renderBackground =
  (path: string, defaultValue?: string): ((UtilThemeProps) => ThemePropValue) =>
  ({ theme }: UtilThemeProps) => {
    const value = getThemeProp(theme, path, defaultValue);

    if (typeof value === "string") {
      return `background: ${value}`;
    }

    return value;
  };

export { renderBackground };
